import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { ClassInfo, AcademicStructure } from '../types';

interface GradebookHeaderProps {
  classInfo: ClassInfo;
  academicStructure: AcademicStructure;
  onStructureChange: (structure: AcademicStructure) => void;
  onExport: () => void;
  onSettings: () => void;
}

const GradebookHeader = ({
  classInfo,
  academicStructure,
  onStructureChange,
  onExport,
  onSettings,
  }: GradebookHeaderProps) => {
  const structureOptions = [
    { value: 'semester', label: 'Semestru' },
    { value: 'trimester', label: 'Trimestru' },
    { value: 'module', label: 'Modul' },
  ];

  return (
    <div className="bg-card border-b border-border p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
            <Icon name="BookOpen" size={24} className="text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-foreground mb-1">
              {classInfo.name} - Catalog
            </h1>
            <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
              <span className="flex items-center gap-1">
                <Icon name="Book" size={14} />
                {classInfo.subject}
              </span>
              <span className="flex items-center gap-1">
                <Icon name="GraduationCap" size={14} />
                {classInfo.grade}
              </span>
              <span className="flex items-center gap-1">
                <Icon name="Calendar" size={14} />
                {classInfo.academicYear}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <div className="w-full sm:w-auto">
            <Select
              options={structureOptions}
              value={academicStructure}
              onChange={(value) => onStructureChange(value as AcademicStructure)}
              placeholder="Selectează structura"
            />
          </div>
          <Button
            variant="outline"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Exportă
          </Button>
          <Button
            variant="outline"
            onClick={onSettings}
            iconName="Settings"
            iconPosition="left"
          >
            Setări
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GradebookHeader;
